export default function PembrokePinesHeroSection() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20master-planned%20suburban%20community%20in%20South%20Florida%20with%20tree-lined%20streets%2C%20modern%20single-family%20homes%2C%20green%20parks%2C%20and%20palm%20trees%20under%20a%20bright%20blue%20sky%20with%20warm%20golden%20sunlight%2C%20high%20quality%20real%20estate%20photography%2C%20vibrant%20colors&width=1400&height=800&seq=pp-hero-01&orientation=landscape"
          alt="Pembroke Pines, FL suburban neighborhood"
          className="w-full h-full object-cover object-center"
          width={1400}
          height={800}
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center py-24">
        <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.25em] mb-4">
          Pembroke Pines, Florida — Broward County
        </p>
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Emergency &amp; Expedited Passport Services in{" "}
          <span className="text-[#F6C344]">Pembroke Pines, FL</span>
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-8 leading-relaxed">
          Fast, reliable passport processing for one of Broward County&apos;s largest cities. As fast as 24 hours. No appointment needed to start — just ship your documents overnight.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start Your Passport <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 text-white hover:text-[#F6C344] font-medium text-base transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> 877-253-0084
          </a>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/60 text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-[#F6C344]"></i> Registered State Dept. Courier
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-award-line text-[#F6C344]"></i> A+ BBB Rating
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-[#F6C344]"></i> 20+ Years Experience
          </span>
        </div>
      </div>
    </section>
  );
}